import { owcTheme } from '@one/design-tokens/js/regular/navify/light';
import { OwcListItem } from '@one/react';
import styled from 'styled-components';

export const LanguageTriggerPrefix = styled.span<{ $open?: boolean }>`
  display: flex;
  align-items: center;

  owc-icon {
    transform: rotate(${({ $open }) => ($open ? '-90deg' : '90deg')});
  }
`;

export const LanguageInlineOption = styled(OwcListItem)`
  padding-inline-start: ${owcTheme['one-spacing-base-6']};
`;
